import React from "react";
import "./style.scss";

const Popup = ({ children, startQuiz, classname }) => {
  return (
    <div className={`popup ${classname} ${startQuiz ? "startQuiz" : ""}`}>
      <>{children}</>
    </div>
  );
};

export default Popup;
